import React, { useState, useEffect } from 'react';
import { Folder } from 'stockblocks-client';

const useFilteredBins = (
    bins: Record<string, Folder> = {},
    searchText: string,
    isInSharedFoldersBeta: boolean,
    setInitialLoadComplete: React.Dispatch<React.SetStateAction<boolean>>,
): Folder[] => {
    const [matchingBins, setMatchingBins] = useState<Folder[]>([] as Folder[]);

    useEffect(() => {
        const containsSearchTerm = (bin: Folder): boolean => {
            const searchTerm = searchText.trim().toLowerCase();
            return bin.name.toLowerCase().includes(searchTerm) || (searchTerm === 'me' && bin.isOwnedByMe);
        };

        const searchResults =
            searchText === ''
                ? Object.values(bins)
                : Object.values(bins)
                      .filter((bin) => containsSearchTerm(bin))
                      .filter((bin) => (isInSharedFoldersBeta ? bin.isOwnedByMe : true));

        // eslint-disable-next-line react-hooks/set-state-in-effect
        setMatchingBins(searchResults);
        setInitialLoadComplete(true);
    }, [bins, searchText, isInSharedFoldersBeta, setInitialLoadComplete]);

    return matchingBins;
};

export default useFilteredBins;
